import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const insightsPortalInstacartSiteConfigurationAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.InsightsHideICStoreConfiguration],
  },
]
